import React, { useState } from "react";
import "./Navbar.css";
import logo from "../assets/images/logo-no-background.png"; // Import the logo
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";


const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="Little Smiles Photography" />
      </div>

      {/* Hamburger Icon */}
      <div className="hamburger-icon" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Navigation Links */}
      <ul className={`nav-links ${isMenuOpen ? "nav-links-active" : ""}`}>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/pricing">Pricing</Link>
        </li>
        {/* <li>
          <ScrollLink
            to="about"
            smooth={true}
            duration={500}
            offset={0} // Adjust for navbar height
          >
            About Us
          </ScrollLink>
        </li>
        <li>
          <ScrollLink
            to="portfolio"
            smooth={true}
            duration={500}
            offset={0}
          >
            Portfolio
          </ScrollLink>
        </li> */}
        {/* <li>
          <ScrollLink
            to="book-session-form"
            smooth={true}
            duration={500}
            offset={0}
          >
            Contact
          </ScrollLink>
        </li> */}
        <li><a href="/#about">About</a></li>
        <li><a href="/#portfolio">Portfolio</a></li>
        {/* <li><a href="/#book-session-form">Contact</a></li> */}
        <li><a href="/#book-session-form">Contact</a></li>
      </ul>
    </nav>
  );
};

export default NavBar;
